import { ObjectId } from 'bson';
import { IsBoolean, IsDate, IsDateString, IsMongoId, IsNotEmpty, IsOptional } from 'class-validator';

export class BaseDto<TId extends ObjectId> {
  @IsMongoId()
  @IsNotEmpty()
  _id!: TId;

  @IsDate()
  @IsNotEmpty()
  createdAt!: Date;

  @IsDate()
  @IsNotEmpty()
  updatedAt!: Date;

  @IsDateString()
  @IsOptional()
  deletionDate?: string;

  @IsBoolean()
  @IsOptional()
  deleted?: boolean;
}
